export default __webpack_public_path__ + "static/media/guideline_5.cf932615.svg";